"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function transformToQueryString(data) {
    const queryStringParams = [];
    data.forEach((item, index) => {
        queryStringParams.push(`items[${index}]id=${item.id}`);
        queryStringParams.push(`items[${index}]quantity=${item.quantity}`);
    });
    return queryStringParams.join('&');
}
exports.default = transformToQueryString;
//# sourceMappingURL=transformToQueryString.js.map